module.exports = __webpack_public_path__ + "static/media/landing.48ab83c7.svg";